export const ROLE_APPS = {
  HDA_ROLES: "HDA",
  DASSIST_ROLES: "DASSIST",
};

export const ROLE_NAMES = {
  HDA_OPERATOR: "WAREHOUSEOPERATOR",
  HDA_SUPERADMIN: "SUPERADMIN",
  WAREHOUSEMANAGER: "WAREHOUSEMANAGER",
  ECONOMIC: "ECONOMIC",
  HDA_IT_SUPERADMIN: "ITSUPERADMIN",

  VISITORS: "VISITORS",
  VISITORS_ADMIN: "VISITORS_ADMIN",
  DASSIST_SUPERADMIN: "SUPERADMIN",

  DELAYS_ADMIN: "DELAYS_ADMIN",

  NONE: "NONE",
};
